import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ventai_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    if (status === 402) {
      // Trial expired — hard redirect so the whole app re-renders in the gated state
      if (window.location.pathname !== "/trial-expired") {
        window.location.href = "/trial-expired";
      }
    } else if (status === 401) {
      // Auth endpoints handle their own errors (login/register/google callback).
      const url = err?.config?.url || "";
      const isAuthEndpoint = url.startsWith("/auth/") || url.includes("/auth/");
      if (!isAuthEndpoint) {
        localStorage.removeItem("ventai_token");
        localStorage.removeItem("ventai_user");
        if (window.location.pathname !== "/login" && window.location.pathname !== "/register") {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(err);
  }
);

export default api;
